import { render, staticRenderFns } from "./Popup02Description.vue?vue&type=template&id=08ac5a13&scoped=true"
import script from "./Popup02Description.vue?vue&type=script&lang=js"
export * from "./Popup02Description.vue?vue&type=script&lang=js"
import style0 from "./Popup02Description.vue?vue&type=style&index=0&id=08ac5a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac5a13",
  null
  
)

export default component.exports